import { Swiper, Navigation } from 'swiper/js/swiper.esm.js';

Swiper.use([Navigation]);

// ================================================
//	studio CLIP 荻野さんコラボニットLP（knit2610）
// ================================================

const SP_QUERY = '(max-width: 767px)';

// ------------------------------------------------
//	スクロールアニメーション（.anim → .active）
// ------------------------------------------------
const funcAnim = () => {
	// HTML末尾のインラインで発火済みなら二重に仕込まない
	if (window.__animReady) return;

	const items = document.querySelectorAll('.anim');
	if (!items.length) return;

	// 発火は IntersectionObserver。読み込んだ時点ですでに画面より上にある要素（再読み込み・ページ内リンク）はその場で出す
	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				const passed = entry.boundingClientRect.bottom <= 0;
				if (!entry.isIntersecting && !passed) return;
				entry.target.classList.add('active');
				observer.unobserve(entry.target);
			});
		},
		// 発火位置: 要素の上端が画面の上から 72% まで入ってから
		{ rootMargin: '0px 0px -28% 0px', threshold: 0 }
	);
	items.forEach((el) => observer.observe(el));

	// 取りこぼし防止: 位置の復元やページ内リンクで一気に通り過ぎた要素と、最下部で下 28% に入らないまま終わる要素を出す
	const sweep = () => {
		const end = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
		items.forEach((el) => {
			if (el.classList.contains('active')) return;
			if (end || el.getBoundingClientRect().bottom <= 0) {
				el.classList.add('active');
				observer.unobserve(el);
			}
		});
	};
	window.addEventListener('scroll', sweep, { passive: true });
	window.addEventListener('resize', sweep);
	window.addEventListener('load', sweep, { once: true });
};

// ------------------------------------------------
//	写真の横スワイプ（SPだけ。PCは2枚を横並びで見せる）
// ------------------------------------------------
const funcSlider = () => {
	// 案件CSSの適用完了を待ってから初期化する
	const cssLink = document.querySelector('link[rel="stylesheet"][href*="/assets/css/style"]');
	const cssReady = new Promise((resolve) => {
		if (!cssLink || cssLink.sheet) return resolve();
		cssLink.addEventListener('load', resolve, { once: true });
		cssLink.addEventListener('error', resolve, { once: true });
	});

	cssReady.then(() => {
		const mq = window.matchMedia(SP_QUERY);
		const slides = document.querySelectorAll('.slide');
		let swipers = [];

		const build = () => {
			slides.forEach((slide) => {
				const swiper = slide.querySelector('.swiper-container');
				if (!swiper) return;
				const item = slide.closest('.kn-style__item');
				const dots = item ? item.querySelectorAll('.kn-style__dot') : [];
				const count = item ? item.querySelector('.kn-style__count') : null;
				const total = swiper.querySelectorAll('.swiper-slide').length;
				const nextButton = slide.querySelector('.kn-style__next');

				const instance = new Swiper(swiper, {
					loop: true,
					slidesPerView: 1,
					spaceBetween: 0,
					speed: 500,
					navigation: {
						nextEl: nextButton,
					},
					on: {
						slideChange() {
							const i = this.realIndex;
							dots.forEach((dot, n) => dot.classList.toggle('is-active', n === i));
							if (count) count.textContent = `${i + 1} / ${total}`;
						},
					},
				});
				swipers.push(instance);
			});
		};

		const destroy = () => {
			swipers.forEach((s) => s.destroy(true, true));
			swipers = [];
		};

		const sync = () => {
			if (mq.matches && !swipers.length) build();
			if (!mq.matches && swipers.length) destroy();
		};

		sync();
		if (mq.addEventListener) mq.addEventListener('change', sync);
		else mq.addListener(sync);

		// 画像・フォント到着後／コンテナ幅が変わった時に幅を取り直す
		window.addEventListener('load', () => swipers.forEach((s) => s.update()), { once: true });
		if ('ResizeObserver' in window) {
			const ro = new ResizeObserver(() => swipers.forEach((s) => s.update()));
			slides.forEach((slide) => ro.observe(slide));
		}
	});
};

// ------------------------------------------------
//	他の写真を開いたら、開いていたクレジットは閉じる
// ------------------------------------------------
const funcCreditExclusive = () => {
	const toggles = document.querySelectorAll('.kn-style__toggle');
	if (!toggles.length) return;

	toggles.forEach((el) => {
		el.addEventListener('change', () => {
			if (!el.checked) return;
			toggles.forEach((other) => {
				if (other !== el) other.checked = false;
			});
		});
	});
};

// ------------------------------------------------
//	STYLE ナビ（STYLE の範囲で表示・現在地を強調）
// ------------------------------------------------
const funcNav = () => {
	const nav = document.querySelector('.kn-nav');
	const sections = [...document.querySelectorAll('.kn-style')];
	if (!nav || !sections.length) return;

	const links = [...nav.querySelectorAll('.kn-nav__link')];

	const update = () => {
		const mid = window.innerHeight / 2;
		const first = sections[0].getBoundingClientRect();
		const last = sections[sections.length - 1].getBoundingClientRect();
		nav.classList.toggle('is-show', first.top < mid && last.bottom > mid);

		let current = 0;
		sections.forEach((sec, i) => {
			if (sec.getBoundingClientRect().top < mid) current = i;
		});
		links.forEach((link, i) => link.classList.toggle('is-current', i === current));
		nav.style.setProperty('--kn-nav-i', current);	// 現在地の丸を動かす
	};

	// SP: スクロールしている間だけ出す。止まって少し経ったら引っ込める（見た目の切り替えは CSS）
	const HIDE_DELAY = 1200;
	let hideTimer = 0;
	const moving = () => {
		nav.classList.add('is-moving');
		clearTimeout(hideTimer);
		hideTimer = setTimeout(() => nav.classList.remove('is-moving'), HIDE_DELAY);
	};

	links.forEach((link) => {
		link.addEventListener('click', (e) => {
			const target = document.querySelector(link.getAttribute('href'));
			if (!target) return;
			e.preventDefault();
			window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY, behavior: 'smooth' });
		});
	});

	update();
	window.addEventListener('scroll', update, { passive: true });
	window.addEventListener('scroll', moving, { passive: true });
	window.addEventListener('resize', update);
};

// ------------------------------------------------
//	TOP（スクロール後に表示・スムーススクロール）
// ------------------------------------------------
const funcPagetop = () => {
	const btn = document.querySelector('.kn-pagetop');
	if (!btn) return;

	btn.addEventListener('click', (e) => {
		e.preventDefault();
		window.scrollTo({ top: 0, behavior: 'smooth' });
	});

	const footer = document.querySelector('.kn-footer');

	const toggle = () => {
		btn.classList.toggle('is-show', window.scrollY > 400);
		// フッターが画面に入ったら出したままにする（SP。見た目の切り替えは CSS）
		if (footer) btn.classList.toggle('is-end', footer.getBoundingClientRect().top < window.innerHeight);
	};

	// SP: スクロールしている間だけ出す。止まって少し経ったら引っ込める
	const HIDE_DELAY = 1200;
	let hideTimer = 0;
	const moving = () => {
		btn.classList.add('is-moving');
		clearTimeout(hideTimer);
		hideTimer = setTimeout(() => btn.classList.remove('is-moving'), HIDE_DELAY);
	};

	toggle();
	window.addEventListener('scroll', toggle, { passive: true });
	window.addEventListener('scroll', moving, { passive: true });
	window.addEventListener('resize', toggle);
};

document.addEventListener('DOMContentLoaded', () => {
	funcAnim();
	funcSlider();
	funcCreditExclusive();
	funcNav();
	funcPagetop();
});
